import { NONE_TYPE, identifierName } from '@angular/compiler';
import { MatLegacyPaginatedTabHeader } from '@angular/material/legacy-tabs';

export class SgkbConstains {
    /** メッセージ */
    static readonly MESSAGE = {
        /** メッセージID */
        ID_SGKB: 'sgkb',
        ID_SYS: 'sys',
        ID_FF: 'ff',
        /** API名 */
        APINAME_SGKD036A: 'SGKD036A',
        APINAME_SGKB121A: 'SGKB121A',
        APINAME_SGKB502A: 'SGKB502A',
        APINAME_SGKB575A: 'SGKB575A',
        APINAME_SGKB702A: 'SGKB702A',
        APINAME_SGKB708A: 'SGKB708A',
        APINAME_SGKB709A: 'SGKB709A',
        APINAME_SGKB981A: 'SGKB981A',
        APINAME_SGKB983A: 'SGKB983A',
        APINAME_SGKB986A: 'SGKB986A',
        APINAME_SGKB991A: 'SGKB991A',
        APINAME_SGKB992A: 'SGKB992A',
        APINAME_SGKZ011A: 'SGKZ011A',
        APINAME_SZMA102A: 'SZMA102A',
        APINAME_SZMA103A: 'SZMA103A',
        APINAME_SZMA301A: 'SZMA301A',
        APINAME_SZME004A: 'SZME004A',
        APINAME_SZOA104A: 'SZOA104A',
        APINAME_SZOA109A: 'SZOA109A',
        APINAME_SZOA110A: 'SZOA110A',
        APINAME_SZOA206A: 'SZOA206A',
        APINAME_SZOA304A: 'SZOA304A',
        APINAME_SZOA308A: 'SZOA308A',
        APINAME_SZZA006A: 'SZZA006A',
        APINAME_SZZA024A: 'SZZA024A'
    }

    /** 処理結果コード */
    static readonly RESULT_CD = {
        /** 正常 */
        NORMAL: '0',
        /** 異常 */
        ERROR: '9'
    }

    /** 処理結果詳細コード */
    static readonly RESULT_DETAIL_CODE = {
        /** 正常 */
        SZZZ_N000: 'SZZZ_N000'
    }

    /** エラーコード */
    static readonly ERROR_CODE = {
        /** DB該当データなし TBL＝{0}、検索条件値＝{1} 
         * 置換メッセージ0:対象のテーブル名、置換メッセージ1:検索条件値をカンマ結合
         */
        SZZZ0026: 'SZZZ0026'
    }

    /** コード値 */
    static readonly CODE = {

        /** 最新識別コード(C00450) */
        LATEST_IDENTIFI_CD: {
            /** 最新ではない */
            NOT_LATEST: '0',
            /** 最新 */
            LATEST: '1'
        },

        /** サービス種別コード(C00841) */
        SERVICE_CLY_CD: {
            /** ガス */
            GAS: '01',
            /** 電力 */
            ELE: '11'
        },

        /** プロダクト種別区分コード(C01130) */
        PRDCT_CLY_DIV_CD: {
            /** 家庭用選択約款 */
            HOUSEHOLDTERMS: '20',
            /** 業務用選択約款（申込書） */
            BIZTERMS_APPFORM: '21',
            /** 業務用（申込書） */
            BIZFORM_APPLY: '22',
            /** 業務用選択約款（契約書） */
            BIZTERMS_CONTRACT: '30',
            /** 大口供給 */
            LARGESUPPLY: '32',
            /** 卸供給 */
            OROSHISUPPLY: '80',
            /** 自用 */
            JIYOU: '90',
            /** 低圧 */
            LOWVOLT: 'A1',
            /** 高圧（500kW未満） */
            HIGHVOLT_BELOW500KW: 'A2',
            /** 高圧（500kW以上） */
            HIGHVOLT_ABOVE500KW: 'A3',
            /** 特別高圧 */
            SPECIAL_HIGHVOLTAGE: 'A4',
            /** 入居前点検、空き家修繕工事 */
            PRECHECK_VACANTREPAIR: '99'
        },

        /** 販売形態区分(C30002) */
        SALES_MODEL_DIV: {
            /** 直販 */
            DIRECTSALE: '01'
        },

        /** 更新区分(C40001) */
        UPDATE_DIV: {
            /** 登録 */
            REGIST: '1',
            /** 変更 */
            CHANGE: '2',
            /** 取消 */
            CANCEL: '3'
        },

        /** 受付種別コード(C40101) */
        ACEPT_CLY_CD: {
            /** ガス開栓 */
            GAS_OPEN: '040102',
            /** ガス総合契約開始 */
            GAS_SOUGOU_CTR_START: '040501',
            /** 被総合開栓 */
            HISOUGOU_OPEN: '040601',
            /** ガス契約変更 */
            GAS_CNTRCT_CHANGE: '040201'
        },

        /** 受付ステータス(C40102) */
        ACEPT_STS: {
            /** 承認前 */
            PREAPPROVE: '0100',
            /** 仮登録 */
            TEMPREG: '0500',
            /** 受付登録依頼中 */
            ENTRY_REQUEST: '1000',
            /** 受付登録エラー */
            ENTRY_ERROR: '1500',
            /** 受付登録完了 */
            ENTRY_FINISH: '2000',
            /** 開通受付依頼中 */
            KAITU_ENT_REQ: '3000',
            /** 開通受付依頼エラー */
            KAITU_ENT_ERR: '3500',
            /** 開通結果エラー */
            OPENERROR: '3550',
            /** 開通受付依頼却下 */
            KAITU_ENT_REJECT: '3700',
            /** 受付処理完了 */
            NTRY_COMPLETE: '4000',
            /** マスタ反映エラー */
            MATER_ERROR: '5500',
            /** 完了 */
            COMPLETE: '6000',
            /** 取消 */
            CANCEL: '9000',
            /** 再申請済 */
            REPENDFIN: '9010'
        },

        /** 託送連絡要否フラグ(C40103) */
        TAKUSOU_CNTACT_TRANS_FLG: {
            /** 託送連絡不要 */
            TRANS_NO_CONTACT: '0'
        },

        /** 需要者区分(C40105) */
        JYUYOSHA_DIV: {
            /** 直接入力 */
            DIRECT: '0',
            /** 契約者と同じ */
            SAMEAS_CONTRACTOR: '5'
        },

        /** 契約開始日区分(C41018) */
        CNTRCT_STARTDAY_DIV: {
            /** 定例検針月指定 */
            REGLR_READMON_SPEC: '1',
            /** 契約開始日指定 */
            CNTRCT_START_DATE: '3'
        },

        /** 契約終了日区分(C41019) */
        CNTRCT_ENDDAY_DIV: {
            /** 指定なし */
            NO_TARGET: '1'
        },

        /** 総合契約区分コード(C41021) */
        SOGO_CTR_DIV: {
            /** 総合契約 */
            SOUGOU_CTR: '1'
        },

        /** 申込方法(S00002) */
        SRN_METHOD: {
            /** Ｗｅｂ（直接） */
            WEB_DIRECT: '2',
            /** その他 */
            OTHER: '9'
        },

        /** 総合区分コード(S00019) */
        SOUGOU_DIV_CD: {
            /** 通常 */
            NORMAL: '0',
            /** 総合 */
            SOUGOU: '1',
            /** 被総合 */
            HISOUGOU: '2'
        },

        /** 包括契約登録申請状況コード(S00054) */
        HOUKATSU_CNTRCT_RGST_APLY_CD: {
            /** 申請中 */
            APPLY: '1',
            /** 承認済 */
            APPROVED: '2',
            /** 取消 */
            CANCEL: '9'
        },

        /** ＷＴ契約変更区分コード(S00055) */
        WT_CNTRCT_CHANGE_DIV_CD: {
            /** 主契約の変更 */
            MAINCHANGE: '1',
            /** 付帯契約の変更 */
            SUBCHANGE: '8',
            /** 付帯契約の解約 */
            SUBCANCEL: '9'
        },

        /** ＷＴ適用日区分コード(S00056) */
        WT_ADOPT_DAY_DIV_CD: {
            /** 次回検針日の翌日 */
            NEXT_DAY: '0',
            /** 遡及変更（開栓日orスイッチ日） */
            RETRO_CHANGE: '1'
        },

        /** 託送連係有無フラグ(S00057) */
        TAKUSOU_RENKEI_UMU_FLG: {
            /** 連係しない */
            FALSE: '0',
            /** 連係する */
            TRUE: '1'
        },

        /** 包括契約状態コード(S00061) */
        HOUKATSU_CNTRCT_CD: {
            /** 空白 */
            NONE: '1',
            /** 契約中 */
            CNTRCT: '2',
            /** 解約 */
            CANCEL: '8'
        },

        /** 割引・割増種類コード(S000650) */
        DISCOUNT_PREMIUM_TYPE_CD: {
            /** 定額割引 */
            RATION_DISCOUNT: '1',
            /** 環境貢献加算 */
            RATION_PREMIUM: '2',
            /** 定率割引 */
            FIXED_RATE_DISCOUNT: '3',
            /** 定率割増 */
            FIXED_RATE_PREMIUM: '4'
        },

        /** 契約状況(S00076) */
        CNTRCT_STATUS: {
            /** 現在契約中のみ */
            ACTIVEONLY: '1'
        },

        /** 包括解約申請状況コード(S00088) */
        HOUKATSU_CANCEL_APLY_CD: {
            /** 未申請 */
            NONE: '1',
            /** 申請中 */
            APPLY: '2',
            /** 承認済 */
            APPROVED: '3',
            /** 取消 */
            CANCEL: '9'
        },

        /** 公団床暖の申込書受領フラグ(S00092) */
        KOUDAN_YUKADAN_APPFORM_RECEIVE_FLG: {
            /** 未受領 */
            NOT_RECEIVE: '0',
            /** 受領済 */
            RECEIVED: '1'
        },

        /** 包括契約登録操作コード(S00093) */
        HOUKATSU_CNTRCT_RGST_OPE_CD: {
            /** 照会 */
            INQUIRY: '1',
            /** 登録 */
            REGIST: '2',
            /** 期中契約変更 */
            CHANGE: '3',
            /** 契約更改 */
            RENEWAL: '4',
            /** 解約 */
            CANCEL_CNTRCT: '5',
            /** 承認 */
            APPROVAL: '6',
            /** 取消 */
            CANCEL: '9'
        },

        /** 包括契約登録種別コード(S00103) */
        HOUKATSU_CNTRCT_REGIST_CLY_CD: {
            /** 新規契約 */
            NEW_CNTRCT: '1',
            /** 期中契約変更（需給契約の追加・解除） */
            MID_CHANGE: '2',
            /** 契約更改 */
            RENEWAL: '3'
        },

        /** 開栓結果登録済フラグ(S00104) */
        OPEN_RESULT_REGISTED_FLG: {
            /** 未登録 */
            NOT_REGIST: '0',
            /** 登録済 */
            REGISTED: '1'
        },

        /** 登録ステータス(S00109) */
        REGIST_STATUS: {
            /** 一時保存 */
            TEMPSAVE: '1',
            /** 取消 */
            CANCEL: '9'
        },

        /** 調整単位料金おしらせ発行フラグ(S00122) */
        ADJUST_UNIT_FEE_NTC_HAKKO_FLG: {
            /** 発行する */
            ISSUE: '1'
        },

        /** 手続き完了おしらせ直送可否フラグ(S00130) */
        TETSUZUKI_COMP_NTC_DRT_KAHI_FLG: {
            /** 不可 */
            NONEED: '0',
            /** 可 */
            NEED: '1'
        },

        /** 開栓種別コード(S00138) */
        TURN_ON_CLS_CODE: {
            /** 通常開栓 */
            STDOPEN: '01',
            /** 入居前点検 */
            PRECHECK: '02',
            /** 試運転 */
            TESTRUN: '03',
            /** 空き家修繕工事 */
            VACANTREPAIR: '04'
        },

        /** 契約一覧ソートパターンコード(S00141) */
        CNTRCT_LIST_SORT_PTRN_CD: {
            /** 包括契約 */
            HOUKATSU_CNTRCT: '1',
            /** マイページ */
            MYPAGE: '2'
        },

        /** 取次契約詳細コード(S00170) */
        TORITSUGI_CNTRCT_DETAIL_CD: {
            /** 卸供給 */
            OROSHI_SUPPLY: '3'
        },

        /** 自用フラグ(S00172) */
        JIYOU_FLG: {
            /** 自用 */
            JIYOU: '1'
        },

        /** 料金プラン要確認フラグ(S00175) */
        FEE_PLAN_CONFIRM_FLG: {
            /** 不要 */
            NONEED: '0',
            /** 要 */
            NEED: '1'
        },

        /** 契約手続き完了通知紙希望フラグ(S00176) */
        CNTRCT_TETSUZUKI_CMP_NTC_PAPER_FLG: {
            /** 希望なし */
            NOPREF: '0',
            /** 希望あり */
            PREF: '1'
        },

        /** 契約者情報変更有無フラグ(S00193) */
        CTRPERINFO_CHANGEYESNO_FLG: {
            /** 変更なし */
            NOCHANGE: '0',
            /** 変更あり */
            CHANGE: '1'
        },

        /** 小売開栓結果表示対象フラグ(S00194) */
        RETAILKAISEN_RSLHYOJI_TARGETFLAG: {
            /** 対象 */
            TARGET: '1'
        },

        /** エネルギー種別コード(S10002) */
        ENEGY_CLS_CD: {
            /** 都市ガス */
            CITY_GAS: '1',
            /** LPガス */
            LP_GAS: '2',
            /** 電気 */
            ELE: '3'
        }
    }

    /** コード名称 */
    static readonly CODE_NAME = {
        /** 包括契約状態コード名称(S00061) */
        HOUKATSU_CNTRCT_CD_NAME: {
            /** 空白 */
            NONE: '',
            /** 契約中 */
            CNTRCT: '契約中',
            /** 解約 */
            CANCEL: '解約',
            /** 満了 */
            EXPIRED: '満了'
        }
    }
}